import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import {
    signUpUser as signUpUserAction,
    moveBack as moveBackAction,
    clearAuthNotification as clearAuthNotificationAction,
    trackEmailMismatchAction,
    trackEmailConfirmationInput as trackEmailConfirmationAction,
    trackLoginInsteadClick as trackLoginInsteadAction,
    trackSocialProviderClick as trackSocialProviderClickAction,
    onSkipSocialLinks,
} from '../../actions/auth';

import SignupPage from './SignupPage';

const _mapStateToProps = ({ authentication, form }) => ({
    form,
    email: authentication.email,
    locale: authentication.locale,
    recaptcha2PublicKey: authentication.recaptcha2PublicKey,
    recaptcha3PublicKey: authentication.recaptcha3PublicKey,
    showCaptcha: authentication.displayCaptcha,
    fp: authentication.fp,
    socialSSOSettings: authentication.socialSSOSettings,
    authNotificationOptions: authentication.authNotificationOptions,
    shouldIncludeEmailConfirmation:
        authentication.shouldIncludeEmailConfirmation,
    disableRecaptcha3: authentication.disableRecaptcha3,
});

const _mapDispatchToProps = {
    onSignUpUser: signUpUserAction,
    moveBack: moveBackAction,
    clearAuthNotification: clearAuthNotificationAction,
    trackEmailConfirmationEdit: trackEmailConfirmationAction,
    trackEmailMismatchShowed: trackEmailMismatchAction,
    onLoginInsteadClick: trackLoginInsteadAction,
    onSocialProviderClick: trackSocialProviderClickAction,
    onSkipSocialLinks,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(SignupPage),
);
